/*
 * Базовый путь сборки.
 *
 * Обычная сборка живёт в корне домена, и тогда BASE_URL равен «/» — помощник
 * возвращает путь как есть, поведение продакшена не меняется ни на байт.
 *
 * Демо-сборка вариантов дизайна отдаётся с подпути (`/devver/`). Vite сам
 * переписывает пути к бандлам и к тому, что импортировано из кода, но
 * абсолютные ссылки, написанные руками в разметке («/android», «/aura-logo.png»),
 * он не видит: для него это просто строки. Без префикса они уводили бы с
 * демо-стенда на боевой сайт — и, что хуже, тихо: /android на корне отдаёт
 * index.html, а не 404, так что человек видел бы пустую страницу вместо
 * инструкции.
 *
 * Поэтому все внутренние абсолютные адреса лендинга проходят через u().
 */

/** Префикс сборки без замыкающего слэша: «» в корне, «/devver» на стенде. */
export const BASE = import.meta.env.BASE_URL.replace(/\/+$/, '');

/**
 * Внутренний адрес с учётом базового пути.
 *
 * Внешние ссылки (http…, mailto:, tel:, #якорь) возвращаются нетронутыми:
 * им префикс не нужен, а его добавление их бы сломало.
 */
export function u(path: string): string {
  if (!path.startsWith('/')) return path;
  return BASE + path;
}
